import { render, staticRenderFns } from "./PxCamposCompraViewProjedata.vue?vue&type=template&id=23849708&"
import script from "./PxCamposCompraViewProjedata.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraViewProjedata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports